import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">
        <path d="M0 5400 l0 -5400 5398 2 5397 3 3 5398 2 5397 -5400 0 -5400 0 0
-5400z m10780 5 l0 -5385 -5385 0 -5385 0 0 5385 0 5385 5385 0 5385 0 0
-5385z"/>
<path d="M3615 6491 c18 -9 17 -10 -7 -10 -23 -1 -27 -5 -24 -23 3 -13 5 -31
5 -40 1 -9 9 -19 19 -22 9 -2 -8 -4 -39 -3 -32 1 -56 -2 -56 -8 0 -6 53 -11
131 -13 284 -7 464 -62 681 -207 83 -56 202 -164 284 -260 51 -58 50 -26 -1
58 -114 190 -270 329 -483 432 -98 47 -132 58 -244 80 -89 18 -296 30 -266 16z"/>
<path d="M3518 6483 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"/>
<path d="M3340 6232 c-51 -7 -142 -32 -191 -54 -44 -18 -48 -23 -32 -32 10 -6
20 -11 23 -11 3 0 16 -7 29 -14 20 -11 25 -11 33 0 9 13 5 -8 -10 -51 -3 -8
15 5 39 30 24 25 66 64 93 87 28 23 48 44 45 46 -2 1 -15 1 -29 -1z"/>
<path d="M3155 6070 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M3676 5631 c6 -7 28 -15 50 -18 22 -4 46 -16 56 -28 10 -12 31 -28
48 -35 23 -9 28 -15 18 -21 -10 -7 -10 -9 2 -9 8 0 29 -13 45 -28 17 -15 38
-31 48 -35 10 -4 16 -11 12 -16 -3 -6 14 -22 39 -36 24 -14 47 -32 50 -40 3
-8 10 -15 16 -15 11 0 100 -83 100 -93 0 -12 51 -57 65 -57 8 0 15 -6 15 -14
0 -8 18 -21 40 -30 28 -11 40 -22 40 -36 0 -14 12 -25 40 -36 22 -9 40 -22 40
-29 0 -6 18 -20 40 -30 42 -19 55 -40 43 -71 -6 -17 -5 -18 9 -3 9 8 18 24 21
35 4 18 5 18 6 -1 0 -11 -6 -31 -15 -43 -8 -12 -14 -28 -12 -34 5 -13 48 56
48 76 0 6 5 17 11 23 7 7 12 43 12 82 0 201 -176 335 -623 474 -63 20 -142 43
-175 52 -33 8 -69 18 -80 21 -15 5 -17 3 -9 -5z m179 -61 c3 -5 1 -10 -4 -10
-6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z"/>
<path d="M5410 5521 c0 -5 12 -12 27 -16 55 -13 53 3 53 -441 0 -414 4 -461
33 -384 6 17 16 30 23 30 6 0 40 -15 75 -32 93 -47 184 -51 263 -12 105 51
166 146 167 259 1 114 -39 197 -123 252 -34 23 -55 29 -118 31 -54 3 -87 -1
-114 -12 -21 -9 -42 -16 -47 -16 -5 0 -9 79 -9 175 l0 175 -115 0 c-63 0 -115
-4 -115 -9z m402 -371 c14 -11 36 -44 48 -75 20 -49 22 -68 18 -168 -4 -88 -9
-121 -26 -153 -25 -48 -60 -74 -101 -74 -71 0 -109 42 -118 134 -6 65 12 265
28 300 25 54 105 73 151 36z"/>
<path d="M7133 5210 c-83 -17 -133 -58 -133 -111 0 -49 61 -76 102 -45 9 7 25
35 35 62 23 60 52 78 97 60 37 -15 56 -48 56 -98 0 -51 -37 -92 -107 -118
-166 -62 -203 -96 -203 -189 0 -44 5 -56 34 -89 33 -35 37 -37 98 -37 55 0 69
4 111 33 56 37 57 38 57 14 0 -50 86 -67 194 -39 60 16 73 37 23 37 -58 0 -61
10 -67 242 l-5 210 -34 29 c-53 44 -154 59 -258 39z m157 -311 c0 -123 -35
-183 -107 -183 -21 0 -38 7 -48 20 -18 24 -20 114 -2 137 16 22 139 97 149 91
5 -3 8 -32 8 -65z"/>
<path d="M5188 5202 c-78 -2 -98 -6 -98 -17 0 -9 10 -15 24 -15 14 0 32 -8 41
-17 15 -15 17 -37 13 -177 -4 -165 -9 -187 -51 -234 -28 -30 -88 -46 -121 -31
-38 17 -46 57 -46 219 0 81 -3 175 -6 209 l-7 61 -104 0 c-79 0 -104 -3 -101
-12 3 -7 14 -14 26 -16 11 -2 25 -9 32 -16 6 -8 14 -96 18 -219 9 -231 13
-245 85 -278 76 -34 142 -20 223 46 23 19 44 35 47 35 2 0 3 -19 3 -42 l-1
-41 100 0 c101 0 131 12 77 31 -28 9 -29 13 -35 87 -4 43 -7 156 -7 251 0 95
-3 174 -7 176 -5 2 -52 2 -105 0z"/>
<path d="M6054 5201 c-11 -11 -1 -23 25 -32 31 -11 54 -53 222 -406 32 -68 62
-123 67 -123 12 0 45 73 138 302 10 27 23 47 27 45 5 -1 37 -63 71 -137 95
-205 97 -210 110 -210 6 0 51 109 100 243 49 133 97 250 105 261 9 10 26 22
39 27 13 5 22 14 20 21 -5 13 -178 17 -178 5 0 -4 0 -11 0 -16 0 -5 12 -11 28
-13 21 -2 28 -9 30 -29 4 -32 -88 -291 -101 -286 -14 4 -118 243 -120 274 -2
20 5 30 23 40 54 27 29 35 -109 36 -142 1 -169 -8 -113 -37 41 -21 65 -76 57
-129 -13 -75 -85 -245 -85 -199 0 5 -27 66 -60 136 -33 70 -63 140 -67 156 -5
27 -2 31 26 41 62 22 27 32 -113 33 -76 1 -140 -1 -142 -3z"/>
<path d="M7487 5198 c-14 -8 -11 -11 30 -32 35 -18 54 -50 124 -209 23 -51 49
-110 59 -132 10 -22 34 -82 54 -133 l37 -93 -21 -57 c-56 -151 -142 -220 -163
-131 -9 41 -55 74 -87 64 -31 -10 -60 -46 -60 -73 0 -33 29 -79 54 -86 38 -10
106 -6 139 8 92 39 143 140 293 576 20 58 51 137 69 177 28 61 39 75 75 93 23
12 39 24 36 27 -8 8 -245 7 -253 -1 -4 -3 12 -14 35 -23 23 -9 44 -25 48 -35
10 -32 -5 -103 -46 -220 -36 -105 -46 -126 -53 -117 -8 11 -87 202 -108 261
-23 65 -23 67 -5 87 11 12 25 21 31 21 7 0 18 7 25 15 10 12 10 15 -1 16 -96
4 -303 2 -312 -3z"/>
<path d="M2670 4923 c0 -15 75 -141 115 -193 201 -261 547 -424 890 -418 55 1
83 3 62 5 -28 3 -37 8 -33 18 2 7 -2 19 -10 25 -21 18 -17 38 9 43 21 4 21 4
-3 7 -17 2 -11 5 20 10 42 7 40 7 -25 9 -180 3 -322 33 -489 101 -175 71 -290
152 -434 306 -82 87 -102 104 -102 87z"/>
<path d="M8083 4720 c-18 -11 -33 -25 -33 -30 0 -6 -5 -8 -10 -5 -6 4 -8 15
-5 26 6 17 1 19 -34 19 l-41 0 0 -196 0 -195 38 3 37 3 5 143 c5 138 6 144 30
162 35 27 91 26 118 -3 19 -21 22 -35 24 -162 l3 -140 38 -3 37 -3 0 151 c0
118 -4 159 -16 185 -29 62 -127 85 -191 45z"/>
<path d="M8449 4720 c-59 -31 -82 -80 -83 -176 -1 -72 2 -85 26 -122 38 -56
77 -75 145 -70 42 4 60 11 83 33 l30 29 0 -43 c0 -34 -6 -49 -29 -72 -37 -37
-103 -41 -145 -8 -33 26 -96 32 -96 9 0 -8 8 -25 18 -36 49 -61 172 -77 252
-33 74 40 80 61 80 297 l0 202 -40 0 c-38 0 -40 -1 -40 -32 l0 -32 -16 23
c-35 50 -122 64 -185 31z m166 -80 c26 -28 30 -38 30 -95 0 -49 -5 -70 -21
-92 -54 -73 -146 -49 -175 45 -15 51 -5 103 27 142 21 25 33 30 68 30 34 0 48
-6 71 -30z"/>
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
